import styled from 'styled-components';

const TextoGeral = styled.h2`
    font: normal 17.976px 'Lexend Deca';
    line-height: 22px;

    color: #666666;

    margin-top: 22px;
`

export default TextoGeral;